import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ExistingenduserComponent } from './existingenduser/existingenduser.component';
import { NewenduserComponent } from './newenduser/newenduser.component';
import { CustomerDashboardComponent } from './customer-dashboard/customer-dashboard.component';
import { LogoutComponent } from './logout/logout.component';
import { AssetstatusreportComponent } from '../report-module/assetstatusreport/assetstatusreport.component';
import { AllticketComponent } from '../report-module/allticket/allticket.component';
import { PmsProfileReportComponent } from '../report-module/pms-profile-report/pms-profile-report.component';
// import { CusUnregisteredComponent } from './cus-unregistered/cus-unregistered.component';


const routes: Routes = [
  // {   path: 'bim/cus_unreg', component: CusUnregisteredComponent  },
  { path: 'existing_enduser', component: ExistingenduserComponent },
  { path: 'new_enduser', component: NewenduserComponent },
  {path: 'dashboard', component:CustomerDashboardComponent},
  {path:'logout',component:LogoutComponent},
  {path:'assetStatusReport',component:AssetstatusreportComponent},
  {path:'jobReport',component:AllticketComponent},
  {path:'pmsSummary',component:PmsProfileReportComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BimmoduleRoutingModule { }
